import { FormTemplate } from 'data/template/template.types';

// eslint-disable-next-line import/prefer-default-export
export const cfFtpInfoCreateDialogTemplate: FormTemplate = {
  version: '1.0.0',
  name: 'CF FTP Info',
  key: 'cfFtpInfo',
  main: {
    metadata: {
      layout: {
        rows: [
          ['FTPID', 'FTPTYPE'],
          ['IPADDR', 'PORT'],
          ['USERNAME', 'USERPASSWD'],
          ['DESTPATH', 'FTPFILESEC'],
          ['FTPFILESIZE', 'OPERATORID'],
        ],
      },
    },
    fields: {
      id: {
        type: 'text',
        hide: 'true',
        initial: '',
      },
      FTPID: {
        label: 'FTP Info ID',
        hintMessage: 'Max 16 characters with no spaces',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 16,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      IPADDR: {
        label: 'IP Address',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 42,
            },
          ],
        },
      },
      PORT: {
        label: 'Port',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 256,
            },
            {
              type: 'regexp',
              regexp: ['digits'],
              errorMessage: 'Can include digits. Please re-enter.',
            },
          ],
        },
      },
      USERNAME: {
        label: 'User Name',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 48,
            },
          ],
        },
      },
      USERPASSWD: {
        label: 'Password',
        type: 'password',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 48,
            },
            {
              type: 'regexp',
              regexp: [
                'letters',
                'digits',
                'spaces',
                '-_.~!@#$%^*+?',
              ],
              errorMessage: 'Can include letters, digits, spaces and the following special characters: -_.~!@#$%^*+?. Please re-enter.',
            },
          ],
        },
      },
      FTPTYPE: {
        label: 'FTP Type',
        type: 'select',
        initial: 'FTP',
        options: [
          {
            label: 'Over FTP',
            value: 'FTP',
          },
          {
            label: 'Over SFTP',
            value: 'SFTP',
          },
        ],
      },
      FTPFILESEC: {
        label: 'File Transfer Timeout (Secs)',
        type: 'number',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 256,
            },
            {
              type: 'regexp',
              regexp: ['digits'],
              errorMessage: 'Can include digits. Please re-enter.',
            },
          ],
        },
      },
      FTPFILESIZE: {
        label: 'File Transfer Max. Kbytes',
        type: 'number',
        initial: '',
        validation: {
          validators: [
            {
              type: 'length',
              length: 256,
            },
            {
              type: 'regexp',
              regexp: ['digits'],
              errorMessage: 'Can include digits. Please re-enter.',
            },
          ],
        },
      },
      FILEMODE: {
        label: 'File Mode',
        type: 'select',
        initial: 'ALLINONE',
        options: [
          {
            label: 'CC for multiple targets per file',
            value: 'ALLINONE',
          },
          {
            label: 'CC for one target per file',
            value: 'CASE',
          },
        ],
      },
      DESTPATH: {
        label: 'Dest Directory',
        type: 'text',
        initial: '',
        validation: {
          required: false,
          validators: [
            {
              type: 'length',
              length: 255,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
      OPERATORID: {
        label: 'Operator ID',
        type: 'text',
        initial: '',
        validation: {
          required: true,
          validators: [
            {
              type: 'length',
              length: 2,
            },
            {
              type: 'regexp',
              regexp: ['letters', 'digits', '-_.~!@#$%^*+?/'],
              errorMessage: 'Can include letters, digits and the following special characters: -_.~!@#$%^*+?/. Please re-enter.',
            },
          ],
        },
      },
    },
  },
};
